import { render, staticRenderFns } from "./ConfiguracionesGenerales.vue?vue&type=template&id=47ffd01c"
import script from "./ConfiguracionesGenerales.vue?vue&type=script&lang=js"
export * from "./ConfiguracionesGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports